import gql from 'graphql-tag';

const FranchiseQuery = {
  sendEmailForFranchise: gql`
    query sendEmailForFranchise(
      $name: String!
      $phone: String!
      $email: String!
    ) {
      sendEmailForFranchise(name: $name, phone: $phone, email: $email) {
        success
        error
      }
    }
  `
};

export default FranchiseQuery;
